import { axios } from '@/utils/request'

const api = {
    saiquList: '/wyhadminapi/cba/saiquList',
    saiquOptions: '/wyhadminapi/cba/saiquOptions',

    saiquDetail: '/wyhadminapi/cba/saiquDetail',
    editSaiqu: '/wyhadminapi/cba/editSaiqu',
    addSaiqu: '/wyhadminapi/cba/addSaiqu',

    saijiList: '/wyhadminapi/cba/saijiList',
    saijiDetail: '/wyhadminapi/cba/saijiDetail',
    editSaiji: '/wyhadminapi/cba/editSaiji',


    serviceTypeList: '/wyhadminapi/cba/serviceTypeList',
    serviceTypeDetail: '/wyhadminapi/cba/serviceTypeDetail',
    addServiceType: '/wyhadminapi/cba/addServiceType',
    editServiceType: '/wyhadminapi/cba/editServiceType',
    serviceTypeDelete: '/wyhadminapi/cba/serviceTypeDelete',


    applyList: '/wyhadminapi/cba/applyList',
    applyDetail: '/wyhadminapi/cba/applyDetail',
    editApply: '/wyhadminapi/cba/editApply',
    getApplyOrderDetail: '/wyhadminapi/cba/applyOrderDetail',
    editApplyOrder: '/wyhadminapi/cba/editApplyOrder',

    applySubjectList: '/wyhadminapi/cba/applySubjectList',
    applySubjectDetail: '/wyhadminapi/cba/applySubjectDetail',
    editApplySubject: '/wyhadminapi/cba/editApplySubject',


    applyDelete: '/wyhadminapi/cba/applyDelete',



    subjectMemberLimitList: '/wyhadminapi/sai/subjectMemberLimitList',
    setSubjectMemberLimit: '/wyhadminapi/sai/setSubjectMemberLimit',

    subject2MusicList: '/wyhadminapi/sai/subject2MusicList',
    setSubjectMusicLimit: '/wyhadminapi/sai/setSubjectMusicLimit',
    setSubjectMusic: '/wyhadminapi/sai/setSubjectMusic',
    getSubjectTypeOptions: '/wyhadminapi/sai/subjectTypeOptions',
    subjectDelete: '/wyhadminapi/sai/subjectDelete',

}

export default api

export function getSaijiList(parameter) {
  return axios({
    url: api.saijiList,
    method: 'get',
    params: parameter
  })
}

export function getSaijiDetail(parameter) {
  return axios({
    url: api.saijiDetail,
    method: 'get',
    params: parameter
  })
}

export function editSaiji(parameter) {
  return axios({
    url: api.editSaiji,
    method: 'post',
    data: parameter
  })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}

export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}


export function getServiceTypeList(parameter) {
    return axios({
        url: api.serviceTypeList,
        method: 'get',
        params: parameter
    })
}


export function addServiceType(parameter) {
    return axios({
        url: api.addServiceType,
        method: 'post',
        data: parameter
    })
}

export function editServiceType(parameter) {
    return axios({
        url: api.editServiceType,
        method: 'post',
        data: parameter
    })
}
export function getServiceTypeDetail(parameter) {
    return axios({
        url: api.serviceTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function serviceTypeDelete(parameter) {
    return axios({
        url: api.serviceTypeDelete,
        method: 'post',
        data: parameter
    })
}



export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getApplySubjectList(parameter) {
    return axios({
        url: api.applySubjectList,
        method: 'get',
        params: parameter
    })
}

export function applySubjectDetail(parameter) {
    return axios({
        url: api.applySubjectDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplySubject(parameter) {
    return axios({
        url: api.editApplySubject,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}


export function subjectOptions(parameter) {
    return axios({
        url: api.subjectOptions,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicList(parameter) {
    return axios({
        url: api.subjectMusicList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicDetail(parameter) {
    return axios({
        url: api.subjectMusicDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectMusic(parameter) {
    return axios({
        url: api.editSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function addSubjectMusic(parameter) {
    return axios({
        url: api.addSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function subjectMusicDelete(parameter) {
    return axios({
        url: api.subjectMusicDelete,
        method: 'post',
        params: parameter
    })
}


export function subjectTypeList(parameter) {
    return axios({
        url: api.subjectTypeList,
        method: 'get',
        params: parameter
    })
}
export function subjectTypeDetail(parameter) {
    return axios({
        url: api.subjectTypeDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectType(parameter) {
    return axios({
        url: api.editSubjectType,
        method: 'post',
        data: parameter
    })
}
export function addSubjectType(parameter) {
    return axios({
        url: api.addSubjectType,
        method: 'post',
        data: parameter
    })
}
export function subjectTypeDelete(parameter) {
    return axios({
        url: api.subjectTypeDelete,
        method: 'post',
        params: parameter
    })
}



export function getSubjectMemberLimitList(parameter) {
    return axios({
        url: api.subjectMemberLimitList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMemberLimit(parameter) {
    return axios({
        url: api.setSubjectMemberLimit,
        method: 'post',
        data: parameter
    })
}
export function getSubjectMusicList(parameter) {
    return axios({
        url: api.subject2MusicList,
        method: 'get',
        params: parameter
    })
}
export function setSubjectMusic(parameter) {
    return axios({
        url: api.setSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function getSubjectTypeOptions(parameter) {
    return axios({
        url: api.getSubjectTypeOptions,
        method: 'get',
        params: parameter
    })
}
export function saiquOptions(parameter) {
    return axios({
        url: api.saiquOptions,
        method: 'get',
        params: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function subjectDelete(parameter) {
    return axios({
        url: api.subjectDelete,
        method: 'post',
        data: parameter
    })
}